import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full text-center flex flex-auto justify-center" }
const _hoisted_2 = { class: "w-full text-center" }
const _hoisted_3 = { class: "flex flex-row justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ps_label = _resolveComponent("ps-label")!
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_modal = _resolveComponent("ps-modal")!

  return (_openBlock(), _createBlock(_component_ps_modal, {
    ref: "psmodal",
    maxWidth: "400px",
    isClickOut: false,
    theme: " lg:px-8 px-6 py-6 lg:rounded-2xl rounded-xl",
    class: "z-20"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'exclamation-triangle'],
          class: "text-yellow-300 mt-1 me-2",
          size: "lg"
        }),
        _createVNode(_component_ps_label, { class: "font-medium text-lg lg:text-xl" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ps_label, { class: "font-light text-xs lg:text-sm" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.message), 1)
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ps_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actionClicked('no'))),
          textSize: "text-xxs lg:text-sm",
          class: "py-3",
          theme: "bg-secondary-300 dark:bg-secondaryDark-grey text-textLight dark:text-primaryDark-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.cancelButton), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ps_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.actionClicked('yes'))),
          textSize: "text-xxs lg:text-sm",
          class: "py-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.okButton), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512))
}